module.exports = __webpack_public_path__ + "static/media/cbs-logo.c37b2b23.svg";